import 'twin.macro';
import 'styled-components/macro';

import { Maybe } from 'types/graphql-toy';

import { SweetCard, SweetCardItem } from '../sweet-card/SweetCard';

interface SweetListProps {
  sweets: Maybe<SweetCardItem[]>;
}

const SweetList = ({ sweets }: SweetListProps) => {
  return (
    <div>
      <h2 tw="display-3 mb-1">There are {sweets?.length || 0} sweet(s) available</h2>
      <div tw="grid grid-cols-4 gap-2">
        {sweets?.map(sweet => (
          <SweetCard key={sweet.id} item={sweet} />
        ))}
      </div>
    </div>
  );
};

export default SweetList;
